import BaseStore from 'fluxible/addons/BaseStore';
import Actions from '../constants/Actions';

class OffersStore extends BaseStore {
  constructor(dispatcher) {
    super(dispatcher);
    this.entity = {};
    this.offers = [];
  }

  handleLoadSuccess(param) {
    this.entity = param.entity;
    this.offers = param.offers;
    this.emitChange();
  }

  get() {
    return {
      entity: this.entity,
      offers: this.offers
    };
  }

  dehydrate() {
    return {
      entity: this.entity,
      offers: this.offers
    };
  }

  rehydrate(state) {
    this.entity = state.entity;
    this.offers = state.offers;
  }
}

OffersStore.storeName = 'OffersStore';
OffersStore.handlers = {
  [Actions.LOAD_OFFERS_SUCCESS]: 'handleLoadSuccess'
};

export default OffersStore;



// WEBPACK FOOTER //
// ./src/stores/OffersStore.js